import { AlertCircle, CheckCircle2 } from "lucide-react";

interface Props {
  errors: string[];
}

export function ValidationErrors({ errors }: Props): JSX.Element {
  if (errors.length === 0) {
    return (
      <div className="rounded-md border bg-emerald-50 border-emerald-300 px-3 py-2 text-sm text-emerald-900 flex items-center gap-2">
        <CheckCircle2 className="size-4" />
        Workflow hợp lệ — sẵn sàng publish.
      </div>
    );
  }
  return (
    <div className="rounded-md border bg-rose-50 border-rose-300 px-3 py-2 space-y-1">
      <div className="flex items-center gap-2 text-sm text-rose-900 font-medium">
        <AlertCircle className="size-4" />
        {errors.length} validation error{errors.length > 1 ? "s" : ""}
      </div>
      <ul className="text-xs text-rose-800 list-disc list-inside space-y-0.5">
        {errors.map((e, i) => (
          <li key={i} className="font-mono">
            {e}
          </li>
        ))}
      </ul>
    </div>
  );
}
